module.exports = __webpack_public_path__ + "static/img/card_icon_act@2x.702ddde6.png";